export default "__VITE_IMAGE_ASSET__c5b971cc__";